import React from 'react'
import PropTypes from 'prop-types';
import { SketchPicker } from 'react-color';

import Label from '../label';
import Button from '../button/button'

import './form-colorpicker.styl'
import '../list/template/table-list.styl'
class ColorPicker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open:false,
            color: {
                hex: props.value
            }
        }
        this.open = this.open.bind(this)
        this.onChange = this.onChange.bind(this)
    }

    open(event){
        event.preventDefault();
        this.setState({open: !this.state.open});
    }

    onChange(color) {
        this.setState({color: color})
        let { onChange = false } = this.props
        if(!onChange) {
            return
        }
        onChange(color);
    }

    render() {
        let { label=false, disabled=false } =  this.props;
        let { color= {hex:'#000000'} } = this.state
        let style = { backgroundColor: color.hex, width: '24px', height: '24px' };

        if(disabled){
            return <div className="form form-colorPicker">
                <Label>{label}</Label>
                <ul className="table-list">
                    <div className="table-list-column"><div style={style}></div></div>
                    <div className="table-list-column"><input type="text" className="" size="6" value={color.hex}/></div>
                </ul>
            </div>
        }

        return <div className="form form-colorPicker">
            <Label>{label}</Label>
            {!this.state.open && (
                <ul className="table-list" onClick={e => this.open(e)}>
                    <li className="table-list-row">
                        <div className="table-list-column"><div style={style}></div></div>
                        <div className="table-list-column"><input type="text" className="" size="6" value={color.hex}/></div>
                        <div className="table-list-column"><button><Label>{label + '.onClick'}</Label></button></div>
                        <div className="table-list-column"><Button onClick={this.open} icon="colorPicker"/></div>
                    </li>
                </ul>
            )}

            {this.state.open && (<div className="form-colorPicker-select">
                <SketchPicker  color={color}  onChange={e => this.onChange(e)} />
                <div className="close"><Button onClick={this.open} icon="close"/></div>
                <div className="valid"><Button onClick={e => this.open(e)} label={label + '.onSelected'} /></div>
            </div>)}
        </div>
    }
}

ColorPicker.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool
}

export default ColorPicker
